import {LivePenaltiesModuleConfig} from "./live-penalties-module.config";
import {LivePenaltiesModuleState} from "./models/live-penalties-module.state";
import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";

export class LivePenaltiesModuleStore extends BaseMobxStore {
  static injectables = [LivePenaltiesModuleConfig, LivePenaltiesModuleState];
}

